import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { HotelRoomsCard } from './ui/hotel_rooms_card.js';

/**
 * Entrada de catálogo do `hotel_rooms` (slot chat). A ESCOLHA do quarto mora no
 * drawer de detalhes do `hotel_planner`, que monta este mesmo card com
 * `buildHotelRoomsBlock`; na conversa o kind é o RECIBO congelado da tarifa
 * escolhida (saída do checkout, `viewOnly` → deck empilhado com a seleção no
 * topo) e a lista viva de reescolha quando a tarifa cai.
 */
export const hotelRoomsEntry: GenUiEntry<Extract<ChatUi, { kind: 'hotel_rooms' }>> = {
  kind: 'hotel_rooms',
  slot: 'chat',
  policy: {
    productOf: () => 'hotel',
    reconcileById: true,
    frozenWhen: (ui) => ui.viewOnly === true,
    /** M1 · 1.9 (F.24): sem `freezeWhenSupersededBy`, QUALQUER card mais novo
     *  congelava a lista de quartos — inclusive o card de quarto FOCADO que o
     *  agente emite ao destacar um quarto, e o cliente perdia o toque na lista
     *  justamente quando o agente apontou. Congelam só uma busca nova
     *  (`hotel_planner`) e o checkout (`product_checkout`); outro `hotel_rooms`
     *  (foco, outro hotel) não congela — o reduce já aceita `select_room` com
     *  `stay` fora de `presenting_details`. `frozenWhen` (recibo `viewOnly`) fica. */
    freezeWhenSupersededBy: ['hotel_planner', 'product_checkout'],
  },
  render: ({ ui, note, readOnly, busy, dispatch }) => (
    <HotelRoomsCard ui={ui} note={note} readOnly={readOnly} busy={busy} dispatch={dispatch} />
  ),
};
